import axios from 'axios'
export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    // Blog List Service
    fetchSignedURL({ commit, state, rootState }, fileName) {
        return axios
            .get(
                `${process.env.VUE_APP_API_BASE_URL}/imageurl?image=${fileName}`
            )
            .then((response) => {
                const list = response.data
                return list
            })
    },

    
}
